<template>
  <div class="notif-host">
    <NotificationBannerStack
      :items="notifications.state.banners"
      @open="open"
      @dismiss="dismiss"
      @hold="notifications.holdBanner"
      @release="notifications.releaseBanner"
    />
    <slot />
  </div>
</template>

<script>
import NotificationBannerStack from "./NotificationBannerStack.vue";
import useNotifications from "./useNotifications";

export default {
  name: "NotificationHost",
  components: { NotificationBannerStack },
  setup() {
    return { notifications: useNotifications() };
  },
  computed: {
    currentEmployeeId() {
      return this.$store.state.app?.userData?.employee_id ?? null;
    },
  },
  watch: {
    currentEmployeeId: {
      immediate: true,
      handler(id) {
        this.notifications.setEmployee(id);
      },
    },
  },
  mounted() {
    this.notifications.start();
  },
  beforeUnmount() {
    this.notifications.stop();
  },
  methods: {
    open(item) {
      this.notifications.openNotification(item, this.$router);
    },
    // Закрытие крестиком — пользователь уведомление видел: отмечаем прочитанным.
    dismiss(item) {
      this.notifications.dismissBanner(item.notification_id);
      this.notifications.markRead(item);
    },
  },
};
</script>
